import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  ToastAction,
} from '@/components/ui/toast'
import { useNotificationStore } from '@/stores/notificationStore'

export function Toaster() {
  const { notifications, removeNotification } = useNotificationStore()

  return (
    <ToastProvider>
      {notifications.map((notification) => (
        <Toast
          key={notification.id}
          variant={notification.variant}
          duration={notification.duration || 5000}
          onOpenChange={(open) => {
            if (!open) {
              removeNotification(notification.id)
            }
          }}
        >
          <div className="grid gap-1">
            <ToastTitle>{notification.title}</ToastTitle>
            {notification.description && (
              <ToastDescription>{notification.description}</ToastDescription>
            )}
          </div>
          {notification.action && (
            <ToastAction
              altText={notification.action.label}
              onClick={notification.action.onClick}
            >
              {notification.action.label}
            </ToastAction>
          )}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  )
}
